// Helper reutilizable de análisis Pareto (80/20): ordena descendente y
// marca `esClave` (grupo "vital few") según el umbral acumulado.
export const GetParetoAcumulado = (registros, valorProp = "valor", umbral = 80) => {
    if (!Array.isArray(registros) || registros.length === 0) return [];

    const total = registros.reduce(
        (acc, item) => acc + (Number(item[valorProp]) || 0),
        0
    );

    if (total <= 0) {
        return registros.map((item) => ({
            ...item,
            porcentaje: 0,
            porcentajeAcumulado: 0,
            esClave: false,
        }));
    }

    const ordenado = [...registros].sort(
        (a, b) => (Number(b[valorProp]) || 0) - (Number(a[valorProp]) || 0)
    );

    let acumulado = 0;
    return ordenado.map((item) => {
        const valor = Number(item[valorProp]) || 0;
        const porcentaje = (valor / total) * 100;
        acumulado += porcentaje;
        return {
            ...item,
            porcentaje,
            porcentajeAcumulado: acumulado,
            esClave: acumulado - porcentaje < umbral,
        };
    });
};
